module.exports = __webpack_public_path__ + "static/img/desktop-gold-bg.0b82216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop-gold-bg.jpg
// module id = 1531
// module chunks = 173